import {useContext} from 'react';
import MemberContext from '../../../contexts/MemberContext';
import OnboardingContext from '../../../contexts/OnboardingContext';
import {
  REGISTRY_LANDING_PAGE_URL,
  ONBOARDING_WELCOME_URL,
} from '../../../constants';

const useMembershipStates = () => {
  const {hasError: memberHasError} = useContext(MemberContext);
  const {shouldSeeOnboarding, isFetching: isFetchingOnboarding} = useContext(
    OnboardingContext,
  );

  if (memberHasError) {
    return {
      state: 'redirect',
      redirectUrl: REGISTRY_LANDING_PAGE_URL,
    };
  }

  if (isFetchingOnboarding) {
    return {state: 'loading'};
  }

  if (shouldSeeOnboarding) {
    return {
      state: 'redirect',
      redirectUrl: ONBOARDING_WELCOME_URL,
    };
  }

  return {
    state: 'render',
  };
};

export default useMembershipStates;
